import React, { createContext, useContext, useState } from "react";

const SnackbarContext = createContext();

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    type: "",
    icon: "",
    duration: 4000,
    position: { vertical: "bottom", horizontal: "right" },
  });

  const showSnackbar = ({
    message,
    type,
    icon,
    duration = 4000,
    position = { vertical: "bottom", horizontal: "right" },
  }) => {
    setSnackbar((prevSnackbar) => ({
      ...prevSnackbar,
      open: false,
    }));

    setTimeout(() => {
      setSnackbar({ message, type, icon, open: true, duration, position });
    }, 100);
  };

  const hideSnackbar = () => {
    setSnackbar((prevSnackbar) => ({ ...prevSnackbar, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ snackbar, showSnackbar, hideSnackbar }}>
      {children}
    </SnackbarContext.Provider>
  );
};